import fileDefault from './images/file-blank-solid-240.png';
import fileCSS from './images/file-css-solid-240.png';
import filePdf from './images/file-pdf-solid-240.png';
import filePng from './images/file-png-solid-240.png';

export const ImageConfig = {
    default: fileDefault,
    pdf: filePdf,
    png: filePng,
    css: fileCSS
}